import { REMOVE_RESUME } from '@glass/shared/modules/resumes/resumesReducer';

const removeResumeAction = (resumeId) => ({
  type: REMOVE_RESUME,
  payload: { resumeId },
});

export default removeResumeAction;
